import Config from "@/const/Config";
import { BaseApi } from "./BaseApi";

export class FurideKanriApi extends BaseApi {

  /**
  * 振出残情報CSVチェックをします
  * @param params
  * @returns
  */
  public async checkFurideCSV(): Promise<any> {
    try {
      return await this.post(Config.API_URL + `/furidekanri/checkcsv`, {});
    } catch (e: any) {
      throw e;
    }
  }

  /**
  * 振出残情報CSVダウンロードをします
  * @param params
  * @returns
  */
  public async downloadFurideCSV(): Promise<any> {
    try {
      return await this.getBlobFromPost(Config.API_URL + `/furidekanri/downloadcsv`, {});
    } catch (e: any) {
      throw e;
    }
  }
}
